import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './customDatePicker.css';

const CustomDatePicker = ({ value, onChange, minDate, highlightedDates = [] }) => {
    const parseYMDToLocalDate = (value) => {
        if (value instanceof Date) return value;
        if (typeof value !== 'string') return null;
        const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
        if (!match) return null;
        return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    };

    const normalizeToDate = (input) => {
        if (input instanceof Date) {
            return Number.isNaN(input.getTime()) ? null : input;
        }

        // Support arrays like [{ holiday: 'YYYY-MM-DD' }, ...] if ever passed
        const candidate = input && typeof input === 'object' && 'holiday' in input ? input.holiday : input;
        const parsedYmd = parseYMDToLocalDate(candidate);
        if (parsedYmd) return parsedYmd;

        const parsed = new Date(candidate);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const toYMD = (date) => {
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Check if a date is highlighted (already a holiday)
    const isHighlightedDate = (date) => {
        const target = normalizeToDate(date);
        if (!target) return false;
        const targetKey = toYMD(target);

        return highlightedDates.some((highlightedDate) => {
            const parsedHighlighted = normalizeToDate(highlightedDate);
            if (!parsedHighlighted) return false;
            return toYMD(parsedHighlighted) === targetKey;
        });
    };
    // Add custom class names to tiles
    const tileClassName = ({ date, view }) => {
        if (view === 'month') {
            // Highlight existing holiday dates
            if (isHighlightedDate(date)) {
                return 'highlighted-date';
            }
            
            // Disable past dates
            if (minDate && date < minDate) {
                return 'disabled-date';
            }
        }
        return null;
    };

    // Disable past dates
    const tileDisabled = ({ date, view }) => {
        if (view === 'month' && minDate) {
            return date < minDate;
        }
        return false;
    };

    return (
        <div className="custom-date-picker-wrapper">
            <Calendar
                onChange={onChange}
                value={value}
                minDate={minDate}
                tileClassName={tileClassName}
                tileDisabled={tileDisabled}
                selectRange={false}
                showNeighboringMonth={false}
                prev2Label={null}
                next2Label={null}
                formatShortWeekday={(locale, date) =>
                    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'][date.getDay()]
                }
            />
        </div>
    );
};

export default CustomDatePicker;
